import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  constructor(private elRef: ElementRef) {}

  public ngAfterViewInit() {
    const el = this.elRef.nativeElement;

    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      setTimeout(() => {
        el.focus();
      }, 0);
    } else {
      const nested = el.querySelector('input, textarea');
      if (nested) {
        setTimeout(() => {
          nested.focus();
        }, 0);
      }
    }
  }
}
